const insuranceProviders = [
  'Sun Life Canada',
  'Manulife',
  'Alberta Blue Cross',
  'UnitedHealthcare',
  'Oxford',
  'Canada Life',
];

const bookingSteps = [
  { num: '1', icon: 'ri-shield-check-line', title: 'Verify Coverage', text: 'Confirm acupuncture benefits with your insurance provider.' },
  { num: '2', icon: 'ri-calendar-check-line', title: 'Book Online', text: 'Schedule via our online system or call our office directly.' },
  { num: '3', icon: 'ri-heart-pulse-line', title: 'Attend Session', text: 'Bring your insurance card — we handle all the paperwork.' },
  { num: '4', icon: 'ri-coins-line', title: 'Pay Copay Only', text: 'You pay only your copay or deductible — we submit claims directly.' },
];

const InsuranceInfo = () => {
  return (
    <section
      id="insurance-info"
      className="py-10 sm:py-14 px-4 sm:px-6 lg:px-12 relative overflow-hidden"
      style={{
        backgroundImage: 'url(https://static.readdy.ai/image/296ab9838c8a2f1e2b2bac03a156c5b2/e39cc3c1382913cb68f2386879f01d93.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Faded overlay */}
      <div className="absolute inset-0 bg-white/75"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="flex items-center gap-2 mb-7">
          <div className="w-6 h-[1px] bg-bronze"></div>
          <span className="text-bronze text-[10px] font-sans font-semibold tracking-[0.3em] uppercase">Accessibility & Process</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
          {/* Left: Insurance */}
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl px-6 py-6 shadow-sm">
            <h2 className="font-display text-2xl sm:text-3xl font-light text-charcoal mb-3 italic">
              Insurance &amp; Accessibility
            </h2>
            <p className="text-[11px] sm:text-[13px] text-textGray font-sans font-light mb-4 leading-relaxed">
              We accept most major insurance plans and provide superbills for out-of-network reimbursement.
            </p>
            <div className="flex flex-wrap gap-2 mb-4">
              {insuranceProviders.map((provider) => (
                <span
                  key={provider}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border border-warmGray/20 rounded-full text-[10px] sm:text-[11px] font-sans font-medium text-charcoal"
                >
                  <i className="ri-check-line text-bronze text-[10px]"></i>
                  {provider}
                </span>
              ))}
            </div>
            <div className="flex items-start gap-2 bg-white/70 rounded-lg px-3 py-2.5 border border-warmGray/15">
              <i className="ri-information-line text-bronze text-sm flex-shrink-0 mt-0.5"></i>
              <p className="text-[10px] sm:text-[11px] text-textGray font-sans font-light leading-relaxed">
                Don&apos;t see your insurance? Contact us — we can provide superbills for out-of-network reimbursement.
              </p>
            </div>
          </div>

          {/* Right: Booking Steps */}
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl px-6 py-6 shadow-sm">
            <h2 className="font-display text-2xl sm:text-3xl font-light text-charcoal mb-5 italic">
              Simple Booking Process
            </h2>
            <div className="space-y-3">
              {bookingSteps.map((step) => (
                <div key={step.num} className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-full bg-white border border-bronze/30 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${step.icon} text-bronze text-sm`}></i>
                  </div>
                  <div>
                    <p className="text-[11px] font-sans font-semibold text-charcoal mb-0.5">{step.title}</p>
                    <p className="text-[11px] sm:text-[12px] text-textGray font-sans font-light leading-relaxed">{step.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom: CTA + Hours */}
        <div className="mt-8 pt-6 border-t border-warmGray/20 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-[10px] text-textGray font-sans font-light tracking-wide">
            Tue &amp; Wed: 12:30–7:30 &nbsp;|&nbsp; Thu–Sat: 8:00–5:00 &nbsp;|&nbsp; Mon &amp; Sun: Closed
          </p>
          <button
            onClick={() => window.REACT_APP_NAVIGATE('/booking')}
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-bronze text-white rounded-full text-[11px] font-sans font-semibold hover:bg-softGold transition-all duration-300 cursor-pointer whitespace-nowrap self-start sm:self-auto"
          >
            <span>RESERVE YOUR SESSION</span>
            <i className="ri-arrow-right-line text-xs"></i>
          </button>
        </div>
      </div>
    </section>
  );
};

export default InsuranceInfo;
